module.exports = __webpack_public_path__ + "img/discord-full-logo.e3002a68.svg";